import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { ResponsiveLine } from '@nivo/line';

import { get } from '../services/api';
import colors from '../utils/colors';
import Loading from './Loading/Loading';

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      stats: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchStatistics();
  }

  fetchStatistics = async () => {
    const stats = await get('/admin/statistics');
    if (stats) {
      // Convert date strings back to Date objects for Nivo charts
      stats.users.series.forEach(s => s.data.forEach(d => d.x = new Date(d.x)));
      stats.orders.series.forEach(s => s.data.forEach(d => d.x = new Date(d.x)));
      stats.passes.series.forEach(s => s.data.forEach(d => d.x = new Date(d.x)));
      stats.subscriptions.series.forEach(s => s.data.forEach(d => d.x = new Date(d.x)));
      this.setState({ stats, loading: false });
    } else {
      this.setState({ loading: false });
      // Handle error case
      console.error("Failed to fetch statistics");
    }
  }

  render() {
    const { stats, loading } = this.state;

    if (loading) return <Loading />;
    if (!stats) return <h2>Impossible de charger les statistiques.</h2>;

    return <div>
      {/* Users Chart */}
      <div style={{ margin: 20, height: 400, width: '80%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <h2>Utilisateurs</h2>
          <p style={{ width: 300, color: '#11c', fontWeight: 'bold', fontSize: 20 }}>Moyenne sur 7 jours: + {Math.round(10 * stats.users.average) / 10} utilisateurs par jour</p>
          <p style={{ width: 300, color: '#1c1', fontWeight: 'bold', fontSize: 25, marginLeft: 20 }}>+ {Math.round(stats.users.raise * 100)}% en 7 jours</p>
        </div>
        <ResponsiveLine
          margin={{ bottom: 100, left: 100, top: 50, right: 150 }}
          data={stats.users.series}
          xScale={{ type: 'time', useUTC: false }}
          xFormat="time:%d/%m/%Y"
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
          axisLeft={{ legend: 'Inscriptions', legendOffset: -40, legendPosition: 'middle' }}
          axisBottom={{ format: '%d/%m/%Y', legend: 'Date', legendOffset: 36, legendPosition: 'middle' }}
          colors={[colors.green, colors.blue, colors.error]}
          pointSize={0}
          useMesh={true}
          isInteractive={true}
          legends={[{
            anchor: 'right', direction: 'column', justify: false, translateX: 150, translateY: 0,
            itemWidth: 100, itemHeight: 20, itemsSpacing: 10, symbolSize: 12, symbolShape: 'circle',
            itemDirection: 'left-to-right', itemTextColor: '#777',
          }]}
        />
      </div>

      {/* Orders Chart */}
      <div style={{ margin: 20, height: 400, width: '80%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <h2>Cours</h2>
          <p style={{ width: 300, color: '#11c', fontWeight: 'bold', fontSize: 20 }}>Moyenne sur 7 jours: {Math.round(10 * stats.orders.average) / 10} cours par jour</p>
          <p style={{ width: 300, color: '#1c1', fontWeight: 'bold', fontSize: 25, marginLeft: 20 }}>+ {Math.round(stats.orders.raise * 100)}% en 7 jours</p>
        </div>
        <ResponsiveLine
          margin={{ bottom: 100, left: 100, top: 50, right: 50 }}
          data={stats.orders.series}
          xScale={{ type: 'time', useUTC: false }}
          xFormat="time:%d/%m/%Y"
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
          axisLeft={{ legend: 'Cours', legendOffset: -40, legendPosition: 'middle' }}
          axisBottom={{ format: '%d/%m/%Y', legend: 'Date', legendOffset: 36, legendPosition: 'middle' }}
          colors={[colors.green, colors.blue]}
          pointSize={0}
          useMesh={true}
          isInteractive={true}
        />
      </div>

      {/* Passes (Transactions) Chart */}
      <div style={{ margin: 20, height: 400, width: '80%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <h2>Chiffre d'Affaires (Pass)</h2>
          <p style={{ width: 300, color: '#11c', fontWeight: 'bold', fontSize: 20, marginLeft: 20 }}>Moyenne: {Math.round(300 * stats.passes.average) / 10} € / mois</p>
          <p style={{ width: 300, color: '#1c1', fontWeight: 'bold', fontSize: 25, marginLeft: 20 }}>+ {Math.round(stats.passes.raise * 100)}% en 7 jours</p>
          <p style={{ width: 300, color: '#1c1', fontWeight: 'bold', fontSize: 25, marginLeft: 20 }}>CA Total: {stats.passes.total}€</p>
          <p style={{ width: 300, color: '#1c1', fontWeight: 'bold', fontSize: 25, marginLeft: 20 }}>CA du mois: {stats.passes.month}€</p>
        </div>
        <ResponsiveLine
          margin={{ bottom: 100, left: 100, top: 50, right: 50 }}
          data={stats.passes.series}
          xScale={{ type: 'time', useUTC: false }}
          xFormat="time:%d/%m/%Y"
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
          axisLeft={{ legend: 'CA (€)', legendOffset: -40, legendPosition: 'middle' }}
          axisBottom={{ format: '%d/%m/%Y', legend: 'Date', legendOffset: 36, legendPosition: 'middle' }}
          colors={colors.button_blue}
          pointSize={0}
          useMesh={true}
          isInteractive={true}
        />
      </div>

      {/* Subscriptions Chart */}
      <div style={{ margin: 20, height: 400, width: '80%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <h2>Chiffre d'Affaires (Abonnements)</h2>
          <p style={{ width: 300, color: '#11c', fontWeight: 'bold', fontSize: 20, marginLeft: 20 }}>Moyenne: {Math.round(300 * stats.subscriptions.average) / 10} € / mois</p>
          <p style={{ width: 300, color: '#1c1', fontWeight: 'bold', fontSize: 25, marginLeft: 20 }}>+ {Math.round(stats.subscriptions.raise * 100)}% en 7 jours</p>
          <p style={{ width: 300, color: '#1c1', fontWeight: 'bold', fontSize: 25, marginLeft: 20 }}>CA Total: {stats.subscriptions.total}€</p>
          <p style={{ width: 300, color: '#1c1', fontWeight: 'bold', fontSize: 25, marginLeft: 20 }}>CA du mois: {stats.subscriptions.month}€</p>
        </div>
        <ResponsiveLine
          margin={{ bottom: 100, left: 100, top: 50, right: 50 }}
          data={stats.subscriptions.series}
          xScale={{ type: 'time', useUTC: false }}
          xFormat="time:%d/%m/%Y"
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
          axisLeft={{ legend: 'CA (€)', legendOffset: -40, legendPosition: 'middle' }}
          axisBottom={{ format: '%d/%m/%Y', legend: 'Date', legendOffset: 36, legendPosition: 'middle' }}
          colors={colors.button_blue}
          pointSize={0}
          useMesh={true}
          isInteractive={true}
        />
      </div>
    </div>
  }
}

export default withRouter(Home);
